var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"careers-header"},[(this.$route.params.page === 'application-form')?_c('app-header-mini',{attrs:{"img":'/static/img/careers/header.jpg',"texts":['Кандидатствай онлайн']}}):_c('app-header-mini',{attrs:{"img":'/static/img/careers/header.jpg',"texts":['Кариери']}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-242c9be5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/careers/Header.vue
// module id = null
// module chunks = 